import { Component } from "react"
import withRouter from "../../services/util/withRouter"
import { connect } from "react-redux"
import DeviceDetailer from "../../views/VMlistComponens/DeviceDetailer/DeviceDetailer";
import DeviceMonitorEditorBased from "../../views/VMlistComponens/DeviceDetailer/DeviceMonitorEditorBased";
import machineAPI from "../../services/api/machines";
import realtime from "../../services/api/realtime";

const mapStateToProps = state => ({
    pluginToken: state.pluginToken
})

class DeviceControlPlugin extends Component {
    componentDidMount() {               
        document.body.style.backgroundColor = "#444d58";

        const searchParams = new URLSearchParams(this.props.location.search);
        const pluginToken = searchParams.get('pluginToken');
        const hardwareID = searchParams.get('hardwareID');

        this.getVMDetails(pluginToken, hardwareID);    
    }

    async getProducts(pluginToken, vendingMachineID) {
        const result = await machineAPI.getProducts(
                vendingMachineID,
                null
            );			
        this.setState({ products: result.response || [] });
    }

    getVMDetails(pluginToken, hardwareID) {
        machineAPI.getVMDetailsByHardwareID(hardwareID)
            .then(async response => {
                const { machine } = response.data;
                this.setState({ machine });
                
                await this.getProducts(pluginToken, machine.vmID);
                await realtime.turnOnLCD(machine.hardwareID);
            })
            .catch(error => {
                console.error("Error fetching VM details:", error);
                // Handle error appropriately, e.g., show an error message to the user
            });
    }

    componentWillUnmount() {
        const { machine } = this.state || {};
        if (machine) {
            realtime.turnOffLCD(machine.hardwareID);
            realtime.turnOnRemoteControl(machine.hardwareID);
        }        
    }


    render() {
        const { machine, products } = this.state || {};
        
        return (
            <div>
                <DeviceMonitorEditorBased  machine={machine} products={products} hideHeader={true}/>            
            </div>
        )
    }   

}

export default connect(mapStateToProps)(withRouter(DeviceControlPlugin))